<template>
	<div v-auto-animate class="space-y-2">
		<slot />
	</div>
</template>
